import React, { useState, useEffect } from 'react';
import {
  Form,
  Card,
  Space,
  Input,
  Tag,
  Row,
  Col,
  Select,
  Spin,
  message,
  Tooltip
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import { useDispatch } from 'react-redux';
import { getAlllclist, downloadLc } from '../../redux/slice';
import Layout from '@/common/Layout';
import { useParams } from 'react-router-dom';
import {
  CloudDownloadOutlined,
  EyeOutlined,
  FileDoneOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';
import { getLoggedInUser, getRoles } from 'utilities/helpers';
import { isWipOnlyLc } from 'utilities/lcWorkflow';
import { getAllDispenses } from '@/features/dispensing/redux/slice';
import CustomModal from '@/common/CustomModal';

const LineClearenceList = () => {
  const [form] = Form.useForm();
  const params = useParams();

  const dispatch = useDispatch();

  const { Search } = Input;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState('');
  const [LCData, setLCData] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    handleGetAllLCList();
    handleGetAllDispenses();
  }, [page, pageSize, search]);

  useEffect(() => {
    setPage(1);
  }, [pageSize, search]);

  const user = getLoggedInUser();
  const { SuperadminProddata } = getRoles('Production');

  const handleGetAllLCList = () => {
    const payload = params.id
      ? { dispensing_request_id: params.id, page, per_page: pageSize, search }
      : { page, per_page: pageSize, search };
    dispatch(getAlllclist(payload)).then((res) => {
      setLCData(res?.payload?.data);
      setPagination(res?.payload?.pagination);
    });
  };

  const handleGetAllDispenses = () => {
    let payload = { page, per_page: pageSize, search };

    dispatch(getAllDispenses(payload)).then(function (response) {
      if (response?.payload?.success) {
        setDataSource(response?.payload?.data);
      }
    });
  };

  const handleDownloadLC = (id) => {
    let payload = { id };

    dispatch(downloadLc(payload)).then(function (response) {
      if (response?.payload?.success) {
        // window.open(response?.payload?.data, '_blank');
        window.open(
          `${process.env.REACT_APP_STORAGE_URL}${response?.payload?.data
            .split('/')
            .pop()}`,
          '_blank'
        );
        message.success('Report Downloaded successfully');
      }
    });
  };

  const onSearch = (value) => {
    setSearch(value);
  };

  const onChange = (value) => {
    console.log(value);
    history.push(`/qa-lineclearence/${value}`);
  };

  const column1 = [
    {
      title: `Current Batch (Process › Sub Process)`,
      dataIndex: 'current_batch',
      key: 'current_batch',
      ellipsis: true,
      width: '160px',
      render: (text, record) => {
        const dr = record?.['dispensing-request'] || record?.dispensing_request;
        let name = dr?.prod_label_process_master?.process_label_name;
        let sub = dr?.prod_label_sub_process?.sub_process_name;
        // WIP-only stages (compression/inspection) are created with no dispensing
        // request, so the process must come from the LC record's own flags.
        if (!name && !sub) {
          if (record?.is_compression) name = 'Compression';
          else if (record?.is_inspection) name = 'Inspection';
        }
        const suffix =
          name || sub ? ` (${name || 'NA'}${sub ? ` › ${sub}` : ''})` : '';
        return `${text || 'NA'}${suffix}`;
      }
    },
    {
      title: `Current Product`,
      dataIndex: 'current_product',
      key: 'current_product',
      ellipsis: true,
      width: '130px'
    },
    {
      title: 'LC Form Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '130px',
      render: (text, record) => {
        return record?.eqp_lc_master?.line_clr_eqp_name;
      }
    },
    {
      title: 'Equipemnt Name',
      dataIndex: 'eqp_name',
      key: 'eqp_name',
      ellipsis: true,
      width: '70px',
      render: (text) => {
        return text || 'NA';
      }
    },
    {
      title: `Equipemnt ID`,
      dataIndex: 'lc_eqp_id',
      key: 'lc_eqp_id',
      ellipsis: true,
      width: '70px',
      render: (text) => {
        // return record?.eqp_id_lc_master?.lc_eqp_id;
        return text || 'NA';
      }
    },

    {
      title: `Status`,
      dataIndex: 'lc_status',
      key: 'lc_status',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return (
          <Tag
            color={
              record?.lc_status === 'QA LC Pending'
                ? '#ff9933'
                : record?.lc_status === 'Approved'
                ? '#28a745'
                : '#007bff'
            }
          >
            {record?.lc_status}
          </Tag>
        );
      }
    },
    {
      title: `Action`,
      dataIndex: 'current_batch',
      key: 'current_batch',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return (
          <Space style={{ gap: '12px', fontSize: '16px' }}>
            {/* <a
              // href={`/qa-lineclearence/${record.dispensing_request_id}?id=${record.id}`}
              href={`/qa-lineclearence?id=${record.id}`}
            > */}
            <Tooltip placement="top" title={'View LC Checklist'}>
              <EyeOutlined
                onClick={() =>
                  history.push(`/qa-lineclearence?id=${record.id}`)
                }
                // onClick={() => handleView(record?.designation, record?.id)}
              />
            </Tooltip>
            {/* </a> */}
            {record?.lc_status === 'Approved' && (
              <>
                <Tooltip placement="top" title={'Download LC'}>
                  <CloudDownloadOutlined
                    onClick={() => handleDownloadLC(record?.id)}
                  />
                </Tooltip>
                {!isWipOnlyLc(record) &&
                  (user?.user?.role === 'qc_initiator' ? (
                    record?.material_verify_status === 'Approved' ? (
                      <Tooltip placement="top" title={'Material Verification'}>
                        <FileDoneOutlined
                          onClick={() =>
                            history.push(
                              `/material-verification/${record?.dispensing_request_id}`
                            )
                          }
                        />
                      </Tooltip>
                    ) : (
                      ''
                    )
                  ) : (
                    <Tooltip placement="top" title={'Material Verification'}>
                      <FileDoneOutlined
                        onClick={() =>
                          history.push(
                            `/material-verification/${record?.dispensing_request_id}`
                          )
                        }
                      />
                    </Tooltip>
                  ))}
                {/* <CustomButton
                  ghost
                  type="primary"
                  size="small"
                  onClick={() =>
                    history.push(`/material-verification/${record?.id}`)
                  }
                >
                  Material verification
                </CustomButton> */}
                {((user?.user?.role === 'prod_user' &&
                  [2, 3].includes(user?.user?.level)) ||
                  user?.user?.role === 'prod_ebmr') &&
                  (record?.material_verify_status === 'Approved' ||
                    isWipOnlyLc(record)) &&
                  record?.current_batch &&
                  record.current_batch.length >= 8 &&
                  // Hide PV icon for area-only LC forms (e.g. AREA LINE CLEARANCE).
                  // These do not verify any upstream WIPs.
                  record?.eqp_lc_master?.is_area_lc !== true &&
                  // Hide PV icon when the LC's snapshot was captured empty (first-stage LCs
                  // like Granulation have no upstream WIPs to verify). Legacy LCs without a
                  // snapshot have `is_empty === undefined` and keep showing the icon.
                  record?.lc_pv_dropdown_snapshot?.is_empty !== true && (
                    <Tooltip placement="top" title={'Product Verification'}>
                      <SafetyCertificateOutlined
                        onClick={() =>
                          // Always anchor on lc_bmr_eqp_id. A single dispensing_request
                          // can have many LCs (e.g. area + process LCs for the same DR),
                          // each with its own snapshot — the DR-based URL is ambiguous.
                          history.push(`/product-verification/lc/${record?.id}`)
                        }
                      />
                    </Tooltip>
                  )}
              </>
            )}
          </Space>
        );
      }
    }
  ];

  return (
    <>
      <Layout sider={false}>
        <Form form={form} layout="vertical">
          <Card
            title={<span>Line Clearence Checklist</span>}
            className={`${styles.cardStyles_approver}`}
            extra={
              <Space>
                <Search
                  onChange={(e) => handleChange(e)}
                  className={`w-100 ${styles.searchbar}`}
                  justify="start"
                  align="start"
                  placeholder="Search by Current batch"
                />
                {user?.user?.role == 'prod_ebmr' ||
                user?.user?.role == 'prod_user' ||
                SuperadminProddata?.[0]?.level == 2 ? (
                  <CustomButton
                    className={styles.inwardButton}
                    onClick={
                      () => history.push(`/qa-lineclearence`)
                      // setShowModal(true)
                    }
                    type="primary"
                  >
                    Create
                  </CustomButton>
                ) : (
                  ''
                )}
              </Space>
            }
          >
            <div className={`${styles.table_container}`}>
              <CustomTable
                columns={column1}
                dataSource={LCData}
                showPaginationMeta
                pagination={{
                  size: 'small',
                  total: pagination?.total_records || 0,
                  current: page,
                  pageSize: pageSize,
                  onChange: (newPage, newSize) => {
                    if (newSize !== pageSize) {
                      setPageSize(newSize);
                      setPage(1);
                    } else {
                      setPage(newPage);
                    }
                  }
                }}
              />
            </div>
          </Card>

          <FormItem className="text-center">
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.back()}
              type="primary"
            >
              Back to Home
            </CustomButton>
          </FormItem>
        </Form>
        {showModal ? (
          <CustomModal
            title="Select a batch for create a LC"
            visible={showModal}
            width="30%"
            footer={null}
            className={styles.customModal}
            closable={false}
          >
            <Form layout="vertical">
              <Row gutter={24}>
                <Col span={24}>
                  <FormItem
                    label="Batch #"
                    // name="designation"
                    rules={[
                      {
                        required: true,
                        message: 'Select Batch #'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Select
                      showSearch
                      placeholder="Select batch #"
                      optionFilterProp="children"
                      onChange={(e) => onChange(e, 'id')}
                      onSearch={onSearch}
                    >
                      {dataSource ? (
                        dataSource?.map((item, index) => {
                          return (
                            <option value={item.id} key={index}>
                              {item.product_batch_number}
                            </option>
                          );
                        })
                      ) : (
                        <Spin />
                      )}
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <FormItem className="text-center">
                <CustomButton
                  className={styles.inwardButton}
                  onClick={() => setShowModal(false)}
                  type="primary"
                >
                  Close
                </CustomButton>
              </FormItem>
            </Form>
          </CustomModal>
        ) : (
          ''
        )}
      </Layout>
    </>
  );
};
export default LineClearenceList;
